'use client';
/** @jsxImportSource @emotion/react */

import React from 'react';
import type { ReactNode, Ref } from 'react';
import {
  Virtuoso,
  type VirtuosoHandle,
  type VirtuosoProps,
} from 'react-virtuoso';

type VirtualizedListProps<T> = Omit<VirtuosoProps<T, never>, 'children'> & {
  children: (item: T) => ReactNode;
  items: T[];
  // Omit forwardRef alltogether and using a custom ref prop instead.
  virtuosoRef?: Ref<VirtuosoHandle>;
};

export const VirtualizedList = <T,>({
  children,
  items,
  virtuosoRef,
  width = 300,
  ...rest
}: VirtualizedListProps<T>) => {
  return (
    <Virtuoso
      {...rest}
      ref={virtuosoRef}
      data={items}
      itemContent={(index) => children(items[index])}
      tabIndex={-1}
      totalCount={items.length}
      width={width}
    />
  );
};

VirtualizedList.displayName = 'VirtualizedList';
